import gql from "graphql-tag";

export const CYBERSOURCE_SETUP_PAYER_AUTH = gql`
  mutation CybersourceSetupPayerAuth($data: CybersourceSetupPayerAuthInput!) {
    cybersourceSetupPayerAuth(data: $data)
  }
`;
